import * as React from "react";
import type { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { Options } from "react-select/dist/declarations/src/types";
import { Heading } from "~/design-system/Heading";
import { Stack } from "~/design-system/Stack";
import type {
  BasicMultiSelectFieldInputOptionType,
  BasicMultiSelectFieldInputProps,
} from "~/screens/App/components/BasicMultiSelectFieldInput/BasicMultiSelectFieldInput";
import { ProjectsMultiSelectFieldInput } from "~/screens/App/components/ProjectsMultiSelectFieldInput/ProjectsMultiSelectFieldInput";

type ProjectOption = {
  avatar: string;
  label: string;
  type: BasicMultiSelectFieldInputOptionType;
  value: string;
};

type ProjectFilterProps = Omit<
  BasicMultiSelectFieldInputProps<ProjectOption>,
  "options"
> & {
  control: Control;
  onSelect?: (
    value: Options<BasicMultiSelectFieldInputProps<ProjectOption>>
  ) => void;
};

const ProjectFilter = (props: ProjectFilterProps) => {
  const { t } = useTranslation();

  return (
    <Stack space="medium">
      <Heading level="5" css={{ color: "$gray700" }}>
        {t(
          "screens.UserNotificationsScreen.NotificationsFilter.projectLabel",
          "Projects to show"
        )}
      </Heading>
      <ProjectsMultiSelectFieldInput
        {...props}
        control={props.control}
        required
      />
    </Stack>
  );
};

export { ProjectFilter };
export type { ProjectOption };
